import VaultAmountDetailsBase from './base/VaultAmountDetailsBase';

/**
 * @class VaultAmountDetails
 * @extends VaultAmountDetailsBase
 */
class VaultAmountDetails extends VaultAmountDetailsBase {
  convertDetailsToArrayByDenomination() {
    const denominations = [
      'd1',
      'd5',
      'd10',
      'd20',
      'd50',
      'd100',
      'c1',
      'c5',
      'c10',
      'c25',
    ]
    const detailsByDenomination = []
    const { strappedDetails, looseDetails, unfitDetails } = this
    denominations.forEach((denomination) => {
      detailsByDenomination.push({
        denomination,
        strapped: strappedDetails[denomination],
        loose: looseDetails[denomination],
        unfit: unfitDetails[denomination],
      })
    })

    return detailsByDenomination
  }
}

export default VaultAmountDetails;
